package org.example.project.engineletter

import androidx.compose.runtime.Composable
import org.example.project.engineletter.layouts.Rechnungslayout
import org.example.project.utils.All

@Composable
fun RenderInvoiceLetterSys(
    rechnung: All,
    kunde: All,
    unternehmen: All,
    logoSrc: String,
    currentSysUser: All
) {
    Rechnungslayout(
        rechnung = rechnung,
        kunde = kunde,
        unternehmen = unternehmen,
        logoSrc = logoSrc,
        currentSysUser = currentSysUser
    )
}
